import script from "./AdventureFuckOff.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureFuckOff.vue?vue&type=script&setup=true&lang=js"

import "./AdventureFuckOff.vue?vue&type=style&index=0&id=6c65cbbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c65cbbb"]])

export default __exports__